// MUI
import { Box, Card, CardActions, CardContent, Typography, Divider, Button, ButtonGroup, TextField, createTheme } from '@mui/material';

// Components
import Todos from './Todos';

// Contexts
import { TodosContext } from '../contexts/TodosProvider';

// Hooks
import { useState, useContext } from 'react';

// Animations
import { keyframes } from "@emotion/react";

export default function TodoList() {
    const theme = createTheme();

    // todos from context
    const { dispatch, filteration, filterDispatch } = useContext(TodosContext);

    // text field
    const [inputTitle, setInputTitle] = useState("");
    const [inputDetails, setInputDetails] = useState("");

    // animation for adding a todo
    const [shakeIt, setShakeIt] = useState(false);
    const shake = keyframes`
        0% { transform: translateX(0); }
        25% { transform: translateX(-5px); }
        50% { transform: translateX(5px); }
        75% { transform: translateX(-5px); }
        100% { transform: translateX(0); }
    `;

    // show new todo
    function handleAdd() {
        if (inputTitle.trim() !== "") {
            dispatch({ type: "add", payload: { newTitle: inputTitle, newDetails: inputDetails } })
            setInputTitle("");
            setInputDetails("");
            setShakeIt(true);
        }
    }

    // show new todo when using "Enter" key
    function handleEnter(e) {
        if (e.key === "Enter") {
            handleAdd();
        }
    }

    // filteration change
    function handleAll() {
        filterDispatch({ type: "all" });
    }

    function handleCompleted() {
        filterDispatch({ type: "completed" });
    }

    function handleNotCompleted() {
        filterDispatch({ type: "notCompleted" });
    }

    return (
        <>
            <Card sx={{ width: { xs: "300px", md: "500px" }, maxHeight: "85vh", overflowY: "auto", overscrollBehavior: "auto" }}>
                {/* header */}
                <CardContent>
                    <Typography variant="h1" sx={{
                        fontWeight: "bold", textAlign: "center", mb: "10px", fontFamily: "Rakkas",
                        fontSize: { xs: "3rem", md: "6rem" },
                    }}>
                        مهامي
                    </Typography>
                    <Divider />
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 3, }}>
                        <ButtonGroup variant="outlined">
                            <Button className="all" onClick={handleAll}
                                sx={{
                                    fontSize: { xs: "16px", md: "20px" },
                                    backgroundColor: (filteration === "all" ? theme.palette.primary.dark : null),
                                    color: (filteration === "all" ? "white" : theme.palette.primary.dark),
                                    animation: shakeIt ? `${shake} 0.5s linear` : "none",
                                }}
                                onAnimationEnd={() => setShakeIt(false)}
                            >الكل</Button>
                            <Button className="completed" onClick={handleCompleted}
                                sx={{
                                    fontSize: { xs: "16px", md: "20px" },
                                    backgroundColor: (filteration === "completed" ? theme.palette.primary.dark : null),
                                    color: (filteration === "completed" ? "white" : theme.palette.primary.dark)
                                }}>منجز</Button>
                            <Button className="notCompleted" onClick={handleNotCompleted}
                                sx={{
                                    fontSize: { xs: "16px", md: "20px" },
                                    backgroundColor: (filteration === "notCompleted" ? theme.palette.primary.dark : null),
                                    color: (filteration === "notCompleted" ? "white" : theme.palette.primary.dark)
                                }}>غير منجز</Button>
                        </ButtonGroup>
                    </Box>
                    <Todos />
                </CardContent>

                {/* form */}

                <CardActions sx={{
                    display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px",
                    flexDirection: "column", gap: "15px"
                }}>
                    <Box sx={{
                        display: "flex", justifyContent: "center", alignItems: "center",
                        gap: "20px", flexDirection: "column", width: "100%"
                    }}>
                        <TextField value={inputTitle} autoComplete="off" size="normal"
                            label="عنوان المهمة" variant="outlined" sx={{
                                flex: "1",
                                width: "100%",
                            }} onChange={e => setInputTitle(e.target.value)} onKeyDown={(e) => { handleEnter(e) }} />
                        <TextField value={inputDetails} autoComplete="off" size="normal" id="outlined-basic"
                            label="تفاصيل المهمة (اختياري)" variant="outlined" sx={{
                                flex: "1",
                                width: "100%",
                            }} onChange={e => setInputDetails(e.target.value)} onKeyDown={(e) => { handleEnter(e) }} />
                    </Box>
                    <Button disabled={inputTitle.trim() === "" ? true : false} variant="contained" sx={{
                        fontSize: "20px", fontWeight: "bold",
                        padding: "10px 50px", width: "100%",
                        backgroundColor: theme.palette.primary.dark, margin: "0 !important",
                    }} onClick={() => handleAdd()} >إضافة</Button>
                </CardActions>
            </Card>
        </>

    )
}
